import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import * as React from 'react';

export function SvgFolder() {
  return <FolderClosedIcon label="" testId="ads-refreshed-icon" />;
}
